var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _path17, _path18, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchool04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.933594,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#7C92BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.994 153.509L194.994 125.469L272.742 151.511L212.017 180.962L137.994 153.509Z",
    fill: "#2F231F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M273.549 151.214L286.037 145.102L285.858 147.412L273.549 153.757L273.549 151.214Z",
    fill: "#BA6649"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.544 151.228L270.988 149.766L270.989 152.38L273.544 153.771L273.544 151.228Z",
    fill: "#512A1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M228.688 169.971L325.014 122.727V126.057L228.688 173.137V169.971Z",
    fill: "#BA6649"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M228.676 169.963L150.945 143.98L150.997 147.173L228.719 173.155L228.684 169.963H228.676Z",
    fill: "#D29C85"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.93 143.92L247.256 96.7109L325.003 122.753L228.677 169.963L150.93 143.92Z",
    fill: "#D3896E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M235.97 152.955L158.239 126.973L152.984 142.876L230.706 168.858L235.979 152.955H235.97Z",
    fill: "#FFEEE7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M235.969 152.948L158.238 126.966L201.064 112.09L278.786 138.072L235.969 152.948Z",
    fill: "#F2E1DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.969 152.948L158.238 126.966L201.064 112.09L278.786 138.072L235.969 152.948Z",
    fill: "url(#paint0_linear_569_27168)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M235.968 152.946L230.73 169.005L278.786 145.637V138.078L235.968 152.955V152.946Z",
    fill: "#C6AEA4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M312.625 117.301L321.876 124.308L278.773 145.63V138.071L312.625 117.301Z",
    fill: "#C6AEA4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.638 117.271L234.908 91.2891L201.064 112.076L278.786 138.058L312.638 117.271Z",
    fill: "#FFEEE7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M312.638 117.271L234.908 91.2891L201.064 112.076L278.786 138.058L312.638 117.271Z",
    fill: "url(#paint1_linear_569_27168)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200.788 112.164L278.639 137.922L253.175 100.213L175.307 74.6797L200.788 112.164Z",
    fill: "#512A1D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_569_27168",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 175,
    y: 118,
    width: 46,
    height: 16
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.473 133.741L175.305 120.15L216.034 118.398L220.202 131.981L179.473 133.741Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_569_27168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.937 130.287L181.873 128.769L183.202 128.216C183.659 128.026 184.151 127.923 184.66 127.906C185.402 127.871 186.161 128.009 186.869 128.277C188.042 128.708 188.353 129.226 187.395 129.675L187.266 129.726L185.937 130.279M184.263 126.732C183.271 126.775 182.33 126.956 181.51 127.302L177.955 128.786L190.001 133.29L191.882 132.505L187.956 131.038L189.587 130.356C189.665 130.322 189.751 130.287 189.829 130.253C191.641 129.398 191.123 128.32 188.81 127.457C187.378 126.922 185.764 126.663 184.263 126.723",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.774 128.539C196.455 128.556 196.17 128.599 195.972 128.694L195.903 128.729C195.376 128.979 195.54 129.385 196.291 129.661C196.757 129.842 197.361 129.928 197.896 129.902C198.224 129.885 198.526 129.833 198.75 129.739L198.793 129.721C199.294 129.488 199.139 129.065 198.388 128.781C197.905 128.599 197.292 128.522 196.774 128.548",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.111 125.604L193.047 124.085L194.376 123.533C194.833 123.343 195.325 123.24 195.826 123.222C196.559 123.188 197.327 123.326 198.035 123.594C199.208 124.025 199.519 124.534 198.57 124.991L198.432 125.052L197.103 125.613M195.411 122.058C194.419 122.101 193.478 122.282 192.659 122.627L189.104 124.111L201.158 128.624L203.039 127.839L199.105 126.363L200.735 125.69C200.813 125.656 200.899 125.621 200.968 125.587C202.789 124.724 202.263 123.654 199.959 122.791C198.526 122.256 196.913 121.989 195.403 122.058",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.915 120.004L197.068 120.781L209.123 125.285L210.97 124.517L198.915 120.004Z",
    fill: "#C6AEA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.528 121.233C207.57 120.844 207.294 120.301 208.054 119.947L208.149 119.904C208.459 119.774 208.848 119.697 209.27 119.679C209.961 119.653 210.737 119.766 211.428 120.024L208.537 121.241M208.822 118.721C207.829 118.765 206.958 118.946 206.259 119.239C206.19 119.274 206.129 119.291 206.069 119.334C204.309 120.154 204.964 121.362 207.657 122.363C209.426 123.027 211.281 123.338 212.929 123.26C213.939 123.217 214.879 123.027 215.664 122.699C215.742 122.665 215.811 122.639 215.88 122.605C217.33 121.914 217.321 121.086 215.966 120.378L214.215 121.12C214.551 121.379 214.491 121.698 213.939 121.957L213.87 121.992C213.507 122.139 213.076 122.225 212.61 122.242C211.833 122.277 210.944 122.13 210.09 121.811L214.724 119.878L214.025 119.619C212.152 118.92 210.349 118.652 208.822 118.721Z",
    fill: "#C6AEA4"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M157.074 130.5L191.565 142.072",
    stroke: "#F7E5DF",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M156.211 133.113L220.981 154.841",
    stroke: "#F7E5DF",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.303 150.969L232.802 162.54",
    stroke: "#F7E5DF",
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27168",
    x1: 228.828,
    y1: 117.875,
    x2: 224.068,
    y2: 132.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2CABF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890366,
    stopColor: "#FFEEE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27168",
    x1: 241.794,
    y1: 124.927,
    x2: 250,
    y2: 103.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2C8BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687351,
    stopColor: "#FFEFE8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool04);
export default __webpack_public_path__ + "static/media/school_04.074c9695c6412adad78f871d29e61459.svg";
export { ForwardRef as ReactComponent };